import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/signatureStore';

export default mutatorAction('setSignatureInStore', (signatureType, signature) => {
    if (signatureType == 'html') {
        getStore().roamingHtmlSignature = signature;
    } else if (signatureType == 'txt') {
        getStore().roamingTxtSignature = signature;
    }
});
